export default "__VITE_ASSET__5c35a708__"